import axios from "../utils/axios-interceptor";
import JSZip from "jszip";
import overviewData from "../mock-data/overview.json";

export const repoCloneApi = async(payload) => {
  try {
    const res = await axios.get(`/clone_repo/?url=${payload.repoLink}`);
    let data = await res.data;
    data.repoLink = payload.repoLink;
    return { data }
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getGraphApi = async(payload) => {
  try {
    const res = await axios.post(`/getGraph/?url=${payload.repoPath}`, undefined, {
      responseType: "blob"
    });
    const url = new Blob([res.data]);
    const zip = await JSZip.loadAsync(url);

    let htmlContent = await zip.file("html/emerge.html").async("string");

    const createBlobURL = async(filename) => {
      const content = await zip.file(filename).async("blob");
      return URL.createObjectURL(content);
    };

    for (const file of Object.values(zip.files)) {
      if (file.name.endsWith(".css") || file.name.endsWith(".js")) {
        const blobURL = await createBlobURL(file.name);
        const relativePath = file.name.replace("html/", "");
        htmlContent = htmlContent.replace(new RegExp(relativePath, "g"), blobURL);
      }
    }

    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write(htmlContent);
    } else {
      console.error("Failed to open new window. Pop-up blocker might be enabled.");
    }

    return { success: true }; // Return an object instead of a string
  } catch (error) {
    throw new Error(error.message)
  }
}

export const getCodeOverviewApi = async(payload) => {
  try {
    if(window.isMockData){
      const data = overviewData;

      // Simulate a 5-second delay
      return await new Promise((resolve) => {
        setTimeout(() => {
          resolve(data);
        }, 5000);
      });
    } else {
      const res = await axios.post(`/code_overview/?url=${payload.repoPath}`, {selected_model: payload.selected_model}, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
      const data = await res.data
      return data
    }
    

  } catch (error) {
    throw new Error(error.message)
  }
}